export default "__VITE_ASSET__DKdnIyjQ__"